export enum ProjectActionType {
    GET_PROJECT = 'GET_PROJECT',
    SAVE_PROJECT = 'SAVE_PROJECT',
    UPLOAD_PROJECT_FILE = 'UPLOAD_PROJECT_FILE',
    REOPEN_PROJECT = 'REOPEN_PROJECT',
    ACCEPT_GROUP_INVITATION = 'ACCEPT_GROUP_INVITATION',
    DECLINE_GROUP_INVITATION = 'DECLINE_GROUP_INVITATION',
    UPDATE_SECOND_SUPERVISORS = 'UPDATE_SECOND_SUPERVISORS',
    ADD_ADDITIONAL_SUPERVISOR = 'ADD_ADDITIONAL_SUPERVISOR',
    CREATE_PLAGIARISM_CHECK_SUBMISSION = 'CREATE_PLAGIARISM_CHECK_SUBMISSION',
    UPDATE_PROJECT_STATUS = 'UPDATE_PROJECT_STATUS',
    UPDATE_PROJECT_TITLE = 'UPDATE_PROJECT_TITLE',
    UPDATE_PROJECT_DEADLINES = 'UPDATE_PROJECT_DEADLINES',
    UPDATE_PROJECT_DATES = 'UPDATE_PROJECT_DATES',
    RESET_PROJECT = 'RESET_PROJECT',
    DISAGREE_GRADE = 'DISAGREE_GRADE',
    ACCEPT_GRADE = 'ACCEPT_GRADE',
    ADMIN_APPROVE_DECLINE_PROJECT = 'ADMIN_APPROVE_DECLINE_PROJECT',
    SEEN_SECOND_SUPERVISOR = 'SEEN_SECOND_SUPERVISOR',
    ADMIN_ACCEPT_REJECT_PROJECT_REGISTRATION = 'ADMIN_ACCEPT_REJECT_PROJECT_REGISTRATION',
    SEEN_ADMIN_DECLINE_PROJECT_REGISTRATION = 'SEEN_ADMIN_DECLINE_PROJECT_REGISTRATION',
    UNLOCK_PROJECT_GRADING = 'UNLOCK_PROJECT_GRADING',
    RESET_PROJECT_GRADING = 'RESET_PROJECT_GRADING',
    TOGGLE_FINAL_REPORT_AVAILABILITY = 'TOGGLE_FINAL_REPORT_AVAILABILITY',
    COMPLETE_GRADING = 'SAVE_PROJECT',
    ADMIN_SET_AS_FAILED = 'ADMIN_SET_AS_FAILED',
    ADMIN_SET_AS_NOT_FAILED = 'ADMIN_SET_AS_NOT_FAILED',
}
